<template lang="pug">
  .select-technician
    div
      button.change-button(
        :disabled="disabled || loading"
        @click="modal = true, loadTechnicians()"
        data-testid="action-btn-asignar-tecnico"
      ) Asignar técnico
        b-spinner(v-if="loading" class="ml-2" variant="white" small)
    //- Modal de confirmación al cambiar técnico
    SamtekModal(
      title="Asignar técnico"
      v-model="modal"
      id="selectTechnician"
      confirmText="Sí"
      cancelText="Cancelar"
      :loading="assigningTechnician"
      @confirm="saveTechnician"
      @cancel="hideModal"
    )
      div.d-block.text-center
        b-form-select.custom-select#main-select(
          v-model="tecnico" :options="options" data-testid="select-tecnico")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

/** Asigna a técnico que diagnosticará la OT
 * Se encarga de guardar al técnico y pasarla a estado asignado
 */

export default {
  components: {
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  name: 'ActionSelectTechician',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled', 'updateOnly'],
  data() {
    return {
      tecnico: this.ot.tecnico_asignado ? this.ot.tecnico_asignado.id : null,
      modal: false,
      assigningTechnician: false,
    }
  },
  computed: {
    ...mapGetters('TechniciansStore', ['technicians']),
    options() {
      return this.technicians
        .map((t) => {
          //eslint-disable-line
          const names = `${t.tecnico.first_name} ${t.tecnico.last_name}`
          const garantia = `${t.cantidad_ot_garantia}/${t.cantidad_maxima}G`
          const presupuesto = `${t.cantidad_ot_presupuesto}/${t.cantidad_maxima_presupuesto}P`
          const total = `${
            t.cantidad_ot_garantia + t.cantidad_ot_presupuesto
          }/${t.cantidad_maxima_total}T`
          return {
            value: t.tecnico.id,
            text: `${names} (${garantia}) (${presupuesto}) (${total})`, //eslint-disable-line
          }
        })
        .sort((a, b) =>
          a.text.toLowerCase() < b.text.toLowerCase()
            ? -1
            : a.text.toLowerCase() > b.text.toLowerCase()
            ? 1
            : 0
        )
        .concat(
          this.ot.tecnico_asignado
            ? []
            : [
                {
                  value: null,
                  text: 'Seleccione...',
                },
              ]
        )
    },
    hasTechnicians() {
      return this.technicians && this.technicians.length > 0
    },
    noTechniciansMessage() {
      if (this.hasTechnicians) return ''

      const tipo = this.ot.tipo_servicio
      if (tipo === 1) {
        return 'No hay técnicos disponibles con capacidad para Garantías en este momento.'
      }
      if (tipo === 4) {
        return 'No hay técnicos disponibles con capacidad para Presupuestos en este momento.'
      }
      return 'No hay técnicos disponibles en este momento.'
    },
  },
  methods: {
    ...mapActions('OTStore', ['asignNewTechnitian', 'updateTechnitian']),
    ...mapActions('TechniciansStore', ['listTechnicians']),

    async loadTechnicians() {
      try {
        // Construir parámetros para filtrar por capacidad según tipo de servicio
        const params = {}

        // Si la OT tiene tipo_servicio definido, filtramos por capacidad
        if (this.ot.tipo_servicio) {
          params.tipo_servicio = this.ot.tipo_servicio
        }

        await this.listTechnicians({ params, forceReload: true })

        // Mostrar advertencia si no hay técnicos disponibles
        if (!this.hasTechnicians) {
          this.$bvToast.toast(this.noTechniciansMessage, {
            variant: 'warning',
            title: 'Atención',
            autoHideDelay: 5000,
          })
        }
      } catch (error) {
        this.$bvToast.toast('Error al cargar la lista de técnicos', {
          variant: 'danger',
        })
      }
    },

    showModal() {
      this.startLoading()
      this.modal = true
    },
    hideModal() {
      this.stopLoading()
      this.modal = false
    },
    async saveTechnician() {
      try {
        await this.executeWithLoading(async () => {
          this.assigningTechnician = true
          await this.asignNewTechnitian({
            otId: this.ot.ot,
            technitianId: this.tecnico,
          })
          this.$bvToast.toast('Técnico asignado correctamente', {
            variant: 'success',
          })
          await new Promise((resolve) => setTimeout(resolve, 500))
          this.$emit('changed')
          this.assigningTechnician = false
          this.modal = false
          // Recargar lista general de técnicos sin filtro
          this.listTechnicians({ forceReload: true })
        })
      } catch (err) {
        this.assigningTechnician = false
        console.log(err.response)
        this.$bvToast.toast(err.response.data || 'Error al asignar', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
